var map = {
	"./blog.yml": 181,
	"./cloud.yml": 182,
	"./color.yml": 183,
	"./country.yml": 184,
	"./dio.yml": 185,
	"./doc.yml": 186,
	"./emoji.yml": 187,
	"./git.yml": 188,
	"./icon.yml": 189,
	"./license.yml": 190,
	"./link.yml": 191,
	"./metrics.yml": 192,
	"./people.yml": 193,
	"./soft.yml": 194,
	"./src.yml": 195,
	"./status.yml": 196
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 180;